<template>
  <div>
    <uni-popup ref="hisCheck" type="bottom">
      <uni-card title="历史申请单" :is-full="true" :note="true">
        <div class="gridClass">
          <uni-list>
            <div v-for="(item, i) in checkList" :key="i">
              <!-- 手术单做个标识 -->
              <div v-if="item.isSurgery">
                <ListItem :item="item" @selected="onSelected" />
              </div>
              <div v-else class="check-list-item" @click="clickPreDetail(item, i)">
                <div class="pre_wrap">
                  <div class="prescripType">
                    <span> {{ getKeyValueText('item_type', item.prescripOrderType) }}申请单 </span>
                  </div>
                </div>
                <div class="prescrip-wrap">
                  <div class="prescrip-msg">
                    <span>No.{{ item.prescriporderNo }}</span>
                  </div>
                  <div class="prescrip-msg">
                    <span> 日期：{{ dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') }} </span>
                  </div>
                  <div class="prescrip-msg">
                    <span class="['mdrug','diagnose']"> 诊断：{{ sysName }} </span>
                  </div>
                  <div class="prescrip-msg drug">
                    <span> 项目：{{ item.treatmentDetailList[0].itemName }} </span>
                  </div>
                </div>
              </div>
            </div>
          </uni-list>
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="createPrescrip">
            <span class="btn">添加新申请单</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-check-detail
      ref="checkDetail"
      :symptom-name="symptomName"
      :seleted-index="seletedIndex"
      :visit-no="visitNo"
      :checkLength="checkLength"
    />
  </div>
</template>
<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import msCheckDetail from '../ms-check-detail/ms-check-detail.vue'
import ListItem from '@/views/funcPuzzle/chat/surgicalOperation/list-item.vue'
import dayjs from 'dayjs'
export default {
  components: { msCheckDetail, ListItem },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    checkList: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    symptomName: {
      type: [Object, String],
      default: ''
    },
    visitNo: {
      type: [Object, String],
      default: ''
    }
  },
  data() {
    return {
      showAddDrug: false,
      showPrescription: false,
      prescripItem: '',
      seletedIndex: ''
    }
  },
  computed: {
    checkLength: {
      get() {
        return this.checkList.length
      },
      set() {}
    },
    sysName() {
      const { symptomName } = this
      let sysName = ''
      if (symptomName && Array.isArray(symptomName)) {
        sysName = symptomName
          .map(item => {
            return item.symptomName
          })
          .join(',')
      }

      // console.log('sysName, symptomName', sysName, symptomName)
      return sysName
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.hisCheck.open()
      } else {
        this.close()
      }
    },
    value(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dayjs,
    getKeyValueText,
    close() {
      if (!this.$refs.hisCheck) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.hisCheck.close()
    },
    open() {
      this.$refs.hisCheck.open()
    },
    createPrescrip() {
      this.$bus.emit('showSelectCheck')
      this.$bus.emit('createNewCheck', this.checkLength)
      this.close()
    },
    onSelected({ data }) {
      // 手术详情
      this.$emit('selected', data)
      this.$refs.hisCheck.close()
    },
    clickPreDetail(item, i) {
      this.$bus.emit('clickHistoryCheck', item)
      this.seletedIndex = i
      this.$refs.hisCheck.close()
      this.$refs.checkDetail.open()
    }
  },
  mounted() {
    this.$bus.on('backToHisCheck', val => {
      if (val) {
        this.$refs.hisCheck.open()
      }
    })
  },
  unmounted() {
    this.$bus.off('createNewCheck')
    this.$bus.off('showSelectCheck')
    this.$bus.off('clickHistoryCheck')
  }
}
</script>

<style lang="scss" scoped>
.gridClass {
  background-color: #fff;
  height: 18.346667rem;
  overflow-y: scroll;
  padding: 0.682667rem 0.64rem 0;
  z-index: 1100;

  .pre_wrap {
    width: 14.634667rem;
    height: 1.365333rem;
    display: flex;
    // border: .021333rem solid #ececec;
    border-bottom: none;
    background: url(~@funcPuzzle/mini_doctor/history_bg.png) no-repeat;
    background-size: cover;
    border-radius: 0.085333rem;
    .prescripType {
      width: 3.968rem;
      height: 1.365333rem;
      // background-color: #1478FF;
      color: #fff;
      font-size: 0.682667rem;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 1.365333rem;
    }
    .prescripState {
      width: 10.709333rem;
      height: 1.365333rem;

      // background: rgba(20, 120, 255, 0.1);
      font-size: 0.682667rem;

      font-weight: 400;
      color: #888;
      text-align: end;
      padding-right: 0.426667rem;
      line-height: 1.365333rem;
    }
  }
  .prescrip-wrap {
    width: 14.634667rem;
    height: auto;

    padding: 0.682667rem 0.533333rem;
    border: 0.021333rem solid #ececec;
    margin-bottom: 0.682667rem;
    box-sizing: border-box;
    border-top: none;
    border-radius: 0 0 0.085333rem 0.085333rem;
    .prescrip-msg,
    .drug {
      display: flex;
      margin-bottom: 0.768rem;
      text {
        font-size: 0.64rem;
        font-weight: 400;
        color: #222222;
        line-height: 0.64rem;
      }
      .diagnose {
        line-height: 0.853333rem;
      }
    }
    .drug {
      margin-bottom: 0;
    }
  }
  .patientName {
    font-size: 0.725333rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #222222;
  }
}
.footer-box {
  text-align: center;
  width: 686ux;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  font-weight: 500;
  .btn {
    color: #fff;
  }
}
</style>
